// extracted by mini-css-extract-plugin
export default {"zoomModal":"L1-z","image":"M1-z","button":"N1-z","isOverlayShown":"O1-z"};